/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBulletLevel316 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel316(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.667 7.333H7.333v1.334h1.334V7.333ZM6 6v4h4V6H6Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBulletLevel320 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel320(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.833 9.167H9.167v1.666h1.666V9.167ZM7.5 7.5v5h5v-5h-5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBulletLevel324 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel324(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path fillRule="evenodd" clipRule="evenodd" d="M13 11h-2v2h2v-2ZM9 9v6h6V9H9Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconBulletLevel3 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBulletLevel3(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconBulletLevel316 {...iconProps} />;
        case '20':
            return <IconBulletLevel320 {...iconProps} />;
        case '24':
            return <IconBulletLevel324 {...iconProps} />;
        default:
            return <IconBulletLevel324 {...iconProps} />;
    }
});
